export var percentageFinder = function (high, low, target) {
    var totalDiffernce = Number(high) - Number(low);
    var newTarget = Number(target) - Number(low);
    return (newTarget * 100) / totalDiffernce;
};
export function getPercentage(baseValue, curValue) {
    if (baseValue && curValue) {
        return (Number(curValue) / Number(baseValue)) * 100;
    }
    return;
}
